import React from 'react'
import withAnalytics, {initAnalytics} from 'react-with-analytics'
import {Route, BrowserRouter, Switch, withRouter} from 'react-router-dom'

import Index from './pages/index'
import Contact from './pages/contact'
import Hiring from './pages/hiring'
import {Header, Footer, CookieMonster} from './components/'

import './styles/style.css'

initAnalytics('UA-53777436-5')

const Root = () => (
    <Switch>
        <Route exact sensitive path="/kontakt/" component={Contact} />
        <Route exact sensitive path="/kariera/" component={Hiring} />
        <Route exact sensitive path="/" component={Index} />
    </Switch>
)

const Routes = withRouter(withAnalytics(Root))

const App = () => (
    <BrowserRouter>
        <div className="container">
            <div className="wrapper">
                <CookieMonster />
                <Header />
                <Routes />
                <Footer />
            </div>
        </div>
    </BrowserRouter>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js